import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	mainCard: {
		padding: theme.spacing(4.5),
	},
	itemSpacing: {
		marginBottom: theme.spacing(4.5),
	},
	option: {
		border: `2px solid ${theme.palette.divider}`,
		borderRadius: theme.spacing(1),
		display: 'flex',
		alignItems: 'flex-start',
		padding: theme.spacing(2),
		'& + &': {
			marginTop: theme.spacing(3),
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: theme.palette.primary.main,
		},
	},
	optionRadio: {
		margin: -10,
	},
	optionDetails: {
		marginLeft: theme.spacing(2),
	},
	selectedOption: {
		borderColor: theme.palette.primary.main,
	},
	tip: {
		marginTop: theme.spacing(2),
	},
	counterText: {
		color: theme.palette.grey[400],
		textSize: 14,
	},
	inputLabelSpacing: {
		marginBottom: theme.spacing(3),
	},
}));
